export const getEditableTransactionAmount = (transaction) => {
  if (!transaction) return 0;

  if (transaction.isUnclaimedRequest) {
    return parseFloat(transaction.debit || 0);
  }

  if (transaction.debit !== null && transaction.debit !== undefined && transaction.debit !== "") {
    return parseFloat(transaction.debit);
  }

  if (transaction.credit !== null && transaction.credit !== undefined && transaction.credit !== "") {
    return parseFloat(transaction.credit);
  }

  return 0;
};

export const isEditableMonazamLedgerTransaction = (transaction, options = {}) => {
  const { inCombinedTable = false } = options;

  if (!transaction || transaction.isBankCharge) {
    return false;
  }

  const ledgerType = transaction.type || transaction.ledgerType;
  if (ledgerType && ledgerType !== "monazam") {
    return false;
  }

  if (transaction.isUnclaimedRequest) {
    return true;
  }

  if (transaction.accumulativeRequestId) {
    const isOutgoing =
      transaction.hgoUserIds !== undefined && transaction.hgoUserIds !== null;
    if (!isOutgoing || inCombinedTable) {
      return false;
    }
    return (transaction.narration || "").toLowerCase().startsWith("expense");
  }

  const isOutgoing =
    transaction.hgoUserIds !== undefined && transaction.hgoUserIds !== null;
  return !isOutgoing;
};
